// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thank-you-form{padding-top:30px;max-width:300px}@media(min-width:768px){.thank-you-form{max-width:350px}}", ""]);
// Exports
module.exports = exports;
